// Scopes to request when logging in with Azure
export const MICROSOFT_SSO_SCOPES = ['User.Read'];
